import { render, staticRenderFns } from "./createBranch.vue?vue&type=template&id=58104734&scoped=true&"
import script from "./createBranch.vue?vue&type=script&lang=js&"
export * from "./createBranch.vue?vue&type=script&lang=js&"
import style0 from "./createBranch.vue?vue&type=style&index=0&id=58104734&lang=scss&scoped=true&"
import style1 from "./createBranch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58104734",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VAutocomplete,VBtn,VCardText,VIcon,VMenu,VSelect,VSnackbar,VTextField,VTimePicker})
